import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    height: '30px',
    marginBottom: '0.75rem',
  },
  selectorControls: {
    height: '40px',
    marginBottom: '1rem',
  },
  carousel: {
    height: '300px',
    marginBottom: '0.5rem',
  },
  rowContainer: {
    marginRight: '10px',
  },
  roundedElement: {
    borderRadius: '50%',
    height: '30px',
    width: '30px',
    right: '0',
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: '190px',
  },
  disclaimer: {
    height: '30px',
  },
  centerElement: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
};

const SkeletonFaresCarouselBackgroundImage = (props) => {
  const [className, style] = useStyles(props);
  const {
    header,
    selectorControls,
    carousel,
    centerElement,
    disclaimer,
    roundedElement,
    rowContainer,
  } = styles;
  return (
    <Box
      className={`${className} fr-skeleton`}
      style={style}
      dataTestId="skeletonFaresCarouselBackgroundImage"
    >
      <Row gutters>
        <Col xs="8">
          <Box className="fr-skeleton-element" style={header} />
        </Col>
      </Row>
      <Row gutters style={rowContainer}>
        <Col xs="4">
          <Box className="fr-skeleton-element" style={selectorControls} />
          <Row>
            <Col>
              <Box className="fr-skeleton-element" style={carousel} />
            </Col>
          </Row>
        </Col>
        <Col xs="4">
          <Box className="fr-skeleton-element" style={selectorControls} />
          <Row>
            <Col>
              <Box className="fr-skeleton-element" style={carousel} />
              <Row gutters>
                <Col xs="6" style={centerElement}>
                  <Box className="fr-skeleton-element" style={disclaimer} />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs="4">
          <Box className="fr-skeleton-element" style={selectorControls} />
          <Row>
            <Col>
              <Box className="fr-skeleton-element" style={carousel} />
            </Col>
          </Row>
        </Col>
        <Box>
          <Box className="fr-skeleton-element" style={roundedElement} />
        </Box>
      </Row>
      <Row gutters>
        <Col xs="5">
          <Box className="fr-skeleton-element" style={disclaimer} />
        </Col>
      </Row>
    </Box>
  );
};

SkeletonFaresCarouselBackgroundImage.componentName = 'SkeletonFaresCarouselBackgroundImage';

export default SkeletonFaresCarouselBackgroundImage;
